 
import { Component, inject } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  PaswordResetTokenSendCommand,
  UsersClientProvider,
  EntityNotFoundMessage,
  ValidationResult,
} from "src/app/web-api/web-api";
import { finalize } from "rxjs/operators";
import { AlertService } from "src/app/services";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { APP_TITLE_TOKEN } from "src/app/injection-tokens/app-title-token";

@Component({
    templateUrl: "./password-forgot.component.html",
    styleUrls: ["./password-forgot.component.scss"],
    standalone: false
})
export class PasswordForgotComponent {
  private _fb = inject(FormBuilder);
  private _route = inject(ActivatedRoute);
  private _client = inject(UsersClientProvider);
  private _alertService = inject(AlertService);
  appTitle = inject(APP_TITLE_TOKEN);

  public loading = false;
  public wasSuccesfull = false;
  public form: FormGroup = null;

  public constructor() {
    this.form = this._fb.group({
      email: ["", Validators.compose([Validators.required, Validators.email])],
    });

    this._route.queryParamMap.subscribe((params) => {
      const values = {};
      for (const key of params.keys) {
        values[key] = params.get(key);
      }
      this.form.patchValue(values);
    });
  }

  public OnSubmit() {
    if (!this.form.valid) {
      return;
    }
    const command = new PaswordResetTokenSendCommand();
    command.init(this.form.value);
    this.loading = true;
    this._alertService.Clear();
    this._client
      .sendPasswordResetToken(command)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        () => {
          this.wasSuccesfull = true;
          this._alertService.Success(
            $localize`:@@PasswordForgot_SuccessMessage:The request was succesful.\nIn a few minutes you will receive an email with further instructions on how to reset your password.`
          );
        },
        (error) => {
          console.log(error);
          console.log(JSON.stringify(error));
          if (error instanceof EntityNotFoundMessage) {
            this._alertService.Error(
              $localize`:@@PasswordForgot_EmailNotFound:There was no user found for this email.`
            );
            return;
          } else if (error instanceof ValidationResult) {
            FormControlBase.ApplyValidationResultToForm(this.form, error);
            return;
          } else if (error.response) {
            const resp = JSON.parse(error.response);
            this._alertService.Error(resp.error);
            return;
          } else if (error.message) {
            this._alertService.Error(error.message);
            return;
          }
          console.error(error);
        }
      );
  }
}
